var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14304",
    "data-name": "Group 14304",
    transform: "translate(-44 -131.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18073",
    "data-name": "Rectangle 18073",
    transform: "translate(44 131.5)",
    fill: "none",
    stroke: "#5837ab",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 14,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 16,
    transform: "translate(44.5 136)",
    fill: "none",
    stroke: "#5837ab",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y2: 10,
    transform: "translate(48.5 136)",
    fill: "none",
    stroke: "#5837ab",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlueIcon);
export default __webpack_public_path__ + "static/media/dashboard-blue-icon.500257e331493c3ae777a524b675ebdb.svg";
export { ForwardRef as ReactComponent };